import { useState, useEffect, useRef, useCallback } from 'react';
import { useRouter } from 'next/router';
enum OptionMap {
  REFRESH = 1,
  REDIRECT = 2,
  FORWORD = 3,
  BACK = 4,
}
let currentHistory: string[] = [];
let currentIndexs = -1;
let beforeHistory = {
  index: currentIndexs,
  length: 0,
};
const useHistory = () => {
  const router = useRouter();
  const { query } = router;
  const eventId = String(query?.eventid);
  /** 显示路由地址 */
  const [localHistory, updateHistory] = useState<string[]>([]);
  /** 当前显示路由index */
  const [currentIndex, setCurrentIndex] = useState(-1);
  /** 当前用户操作 */
  const userOption = useRef<Number | null>(null);
  /** 上一个路由history */
  /** 上一次记录的history长度 */
  const handlePopstate = useCallback(
    (url: string) => {
      const newHistory = [...currentHistory];
      const historyIndex = window.history?.state?.idx;
      if (newHistory.length === 0 && window.history.length > 2 && historyIndex === 0) {
        // 当前处于页面刷新
        userOption.current = OptionMap.REFRESH;
        // 如果当前存在历史数据则设置当前历史数据
        const historys = sessionStorage.getItem(`${eventId}_history`);
        if (historys) {
          const historyObject = JSON.parse(historys);
          currentIndexs = historyObject?.currentIndex;
          currentHistory = historyObject?.history;
        }
      } else if (newHistory.length === 0) {
        currentHistory = [...newHistory, url];
        currentIndexs = currentIndexs + 1;
      } else if (
        window?.history.length !== beforeHistory.length ||
        (window?.history.length === beforeHistory.length &&
          userOption.current !== OptionMap.REFRESH &&
          url !== newHistory[currentIndexs + 1] &&
          beforeHistory.index < historyIndex)
      ) {
        // 当前属于页面跳转
        // 前一个页面栈长度与当前页面栈长度不一致或者
        // 长度一致但最后一个路径不相同时均认为是页面跳转
        userOption.current = OptionMap.REDIRECT;
        // if(window.history.length>newHistory.length)
        newHistory.splice(
          window.history.length - 1,
          newHistory.length - window?.history?.length + 1,
          url,
        );
        currentHistory = [...newHistory];
        currentIndexs = currentHistory.length - 1;
      } else if (beforeHistory.index < historyIndex) {
        // 当前处于页面前进
        userOption.current = OptionMap.FORWORD;
        currentIndexs = currentIndexs + 1;
      } else if (beforeHistory.index > historyIndex) {
        // 否则为页面回退
        userOption.current = OptionMap.BACK;
        currentIndexs = currentIndexs - 1;
      } else {
        console.log('页面1111222');
      }
      if (window?.history?.state?.idx === 0 && currentIndexs > 1) {
        // 页面刷新后，当前最高路由栈的idx判断跳转不正确
        beforeHistory = {
          index: currentIndexs,
          length: currentHistory.length,
        };
      } else {
        // 设置上一个路由跳转的最高栈
        beforeHistory = {
          index: window?.history?.state?.idx,
          length: window?.history.length,
        };
      }

      setCurrentIndex(currentIndexs);
    },
    [localHistory, currentIndex],
  );
  useEffect(() => {
    updateHistory(currentHistory);
    return () => {
      sessionStorage.setItem(
        `${eventId}_history`,
        JSON.stringify({
          history: currentHistory,
          currentIndex: currentIndexs,
        }),
      );
    };
  }, [currentIndex]);
  useEffect(() => {
    // 使用页面跳转、回退、前进
    /** 集成环境的aspath会多一个/events/host导致识别失败 */
    const url = router?.asPath?.replace('/events/host', '');
    console.log('router.asPath', router.asPath);
    handlePopstate(url);
  }, [router.asPath]);
  /** 后退方法 */
  const handleBack = useCallback(() => {
    if (localHistory?.length < 2) return;
    router.back();
  }, [localHistory]);
  /** 前进方法 */
  const handleForward = () => {
    window.history.forward();
  };
  return {
    localHistory,
    currentIndex,
    handleBack,
    handleForward,
  };
};
export default useHistory;
